import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { Stack } from '@material-ui/core';
import PulseLoader from 'src/components/loaders/PulseLoader';
import ErrorIcon from '@mui/icons-material/Error';
import './RichEditor.css';
const RichText = ({ newText, setNewText, loading, error, originalText, saved, setSaved }) => {
  if (error)
    return (
      <Stack
        direction={'column'}
        style={{
          paddingTop: '1%',
          justifyContent: 'center',
          justifyItems: 'center',
          height: '50vh'
        }}
      >
        <center>
          <h3>
            Something went wrong! <br /> Please reload and try again or contact your adminstrator.
          </h3>
        </center>
        <center>
          <ErrorIcon color="error" style={{ fontSize: 100 }} />
        </center>
      </Stack>
    );

  if (loading)
    return (
      <Stack
        direction={'column'}
        style={{
          paddingTop: '1%',
          justifyContent: 'center',
          justifyItems: 'center',
          height: '50vh'
        }}
      >
        <center>
          <PulseLoader />;
        </center>
      </Stack>
    );
  return (
    <CKEditor
      data={newText == null ? originalText : newText}
      onChange={(event, editor) => {
        const data = editor.getData();
        setNewText(data);
        if (saved) setSaved(!saved);
      }}
      editor={ClassicEditor}
      config={{
        placeholder: 'Add patient history',
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'blockQuote',
          'link',
          'numberedList',
          'bulletedList',
          'insertTable',
          '|',
          'undo',
          'redo'
        ]
      }}
    />
  );
};

export default RichText;
